<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div class="share-dissemination">
    <h1>{{ $t('shareDiss.title') }}</h1>
    <div class="share-dissemination-overview">
      <panelMove
        :userCount="overview.shareAmt.currentRange"
        :tooltipTitle="$t('shareDiss.overview.shareAmt')"
        :tooltipContent="$t('shareDiss.explain[0].content')"
        :userPro="overview.shareAmt.ratio">
      </panelMove>
      <panelMove
        :userCount="overview.shareDeviceAmt.currentRange"
        :tooltipTitle="$t('shareDiss.overview.shareDeviceAmt')"
        :tooltipContent="$t('shareDiss.explain[1].content')"
        :userPro="overview.shareDeviceAmt.ratio">
      </panelMove>
      <panelMove
        :userCount="overview.shareLinkClickAmt.currentRange"
        :tooltipTitle="$t('shareDiss.overview.shareLinkClickAmt')"
        :tooltipContent="$t('shareDiss.explain[2].content')"
        :userPro="overview.shareLinkClickAmt.ratio">
      </panelMove>
      <!-- 暂不支持 新增指标  新增用户数 -->
      <panelMove
        :userCount="overview.newShareDeviceAmt.currentRange"
        :tooltipTitle="$t('shareDiss.overview.newShareDeviceAmt')"
        :tooltipContent="$t('shareDiss.newUserExplain.content')"
        :userPro="overview.newShareDeviceAmt.ratio">
      </panelMove>
      <!--link点击占总打开次数比例-->
      <panelMove
        :userCount="overview.viewAmt.currentRangeRatio"
        :tooltipTitle="$t('shareDiss.overview.linkOfAll')"
        :tooltipContent="$t('shareDiss.linkOfAllExplain.content')"
        :userPro="overview.viewAmt.ratio">
      </panelMove>
    </div>
    <!-- 分享趋势 -->
    <div class="share-dissemination-chart">
      <div class="tooltip-box clearfix">
        <h2 class="second-title">{{ $t('shareDiss.trend') }}</h2>
        <div class="operation">
          <span
            class="iconfont icon-download tm-icon-font hover-style tm-icon-font-portrait"
            @click="exportData">
          </span>
          <Poptip trigger="hover" class="tab-pop" placement="bottom-end">
            <span
              class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
              style="margin-left:10px;"></span>
            <div slot="title">{{ $t('portrait.indexInfo') }}</div>
            <div slot="content">
              <p><span>{{ $t('shareDiss.explain[0].title') }}</span>：
              {{ $t('shareDiss.explain[0].content') }}</p>
              <p><span>{{ $t('shareDiss.explain[1].title') }}</span>：
              {{ $t('shareDiss.explain[1].content') }}</p>
              <p><span>{{ $t('shareDiss.explain[2].title') }}</span>：
              {{ $t('shareDiss.explain[2].content') }}</p>
              <p><span>{{ $t('shareDiss.newUserExplain.title') }}</span>：
                {{ $t('shareDiss.newUserExplain.content') }}</p>
            </div>
          </Poptip>
        </div>
      </div>
      <!-- 图表 -->
      <Tabs value="shareAmt" @on-click="onChangeTabs">
        <TabPane :label="$t('shareDiss.shareAmt.tabs')" name="shareAmt">
          <chart-move
            :show-transform="true"
            chart-name="shareAmt"
            @on-change-chart-type="onChangeChartType"
            ref="shareAmt"
          >
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareAmt.allCount`) }}</span>
              <b>{{ shareAmt.total | numberSeparator }}</b>
            </div>
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareAmt.dayCount`) }}</span>
              <b>{{ shareAmt.average | numberSeparator }}</b>
            </div>
          </chart-move>
        </TabPane>
        <TabPane :label="$t('shareDiss.shareDeviceAmt.tabs')" name="shareDeviceAmt">
          <chart-move
            :show-transform="true"
            chart-name="shareDeviceAmt"
            @on-change-chart-type="onChangeChartType"
            ref="shareDeviceAmt"
          >
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareDeviceAmt.allCount`) }}</span>
              <b>{{ shareDeviceAmt.total | numberSeparator }}</b>
            </div>
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareDeviceAmt.dayCount`) }}</span>
              <b>{{ shareDeviceAmt.average | numberSeparator }}</b>
            </div>
          </chart-move>
        </TabPane>
        <TabPane :label="$t('shareDiss.shareLinkClickAmt.tabs')" name="shareLinkClickAmt">
          <chart-move
            :show-transform="true"
            chart-name="shareLinkClickAmt"
            @on-change-chart-type="onChangeChartType"
            ref="shareLinkClickAmt"
          >
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareLinkClickAmt.allCount`) }}</span>
              <b>{{ shareLinkClickAmt.total | numberSeparator }}</b>
            </div>
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.shareLinkClickAmt.dayCount`) }}</span>
              <b>{{ shareLinkClickAmt.average | numberSeparator }}</b>
            </div>
          </chart-move>
        </TabPane>
        <!-- 暂不支持 新增指标 -->
         <TabPane :label="$t('shareDiss.newShareDeviceAmt.tabs')" name="newShareDeviceAmt">
          <chart-move
            :show-transform="true"
            chart-name="newShareDeviceAmt"
            @on-change-chart-type="onChangeChartType"
            ref="newShareDeviceAmt"
          >
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.newShareDeviceAmt.allCount`) }}</span>
              <b>{{ newShareDeviceAmt.total | numberSeparator }}</b>
            </div>
            <div class="chart-move-metrice-title" slot="chart-move-metrice">
              <span>{{ $t(`shareDiss.newShareDeviceAmt.dayCount`) }}</span>
              <b>{{ newShareDeviceAmt.average | numberSeparator }}</b>
            </div>
          </chart-move>
        </TabPane>
      </Tabs>
    </div>

    <!-- 页面分享分析 -->
    <div class="share-dissemination-page">
      <div class="tooltip-box clearfix" style="border-bottom: 0;">
        <h2 class="second-title">{{ $t('shareDiss.pageShare') }}</h2>
        <div class="operation input-box">
          <Input
            v-model="sharePageFilter"
            icon="ios-search"
            :placeholder="$t('filter.search')"
            style="width: 160px;"
          >
          </Input>
          <span
            style="margin-left: 10px;"
            class="iconfont icon-download tm-icon-font hover-style tm-icon-font-portrait"
            @click="exportPageData">
          </span>
          <Poptip trigger="hover" class="tab-pop" placement="bottom-end">
            <span
              class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
              style="margin-left:10px;"></span>
            <div slot="title">{{ $t('portrait.indexInfo') }}</div>
            <div slot="content">
              <p v-for="item in $t('shareDiss.explain')">
                <span>{{ item.title }}</span>：{{ item.content }}
              </p>
            </div>
          </Poptip>
        </div>
      </div>
      <tableMove
        ref="pageTable"
        table-name="pageTable"
        class="page-table"
        :change-data="pageTableData"
        :table-columns="pageTableColumns"
        :noData="pageNoData"
        :filterKey="['pageNm']"
        :filterValue="sharePageFilter"
        @on-table-move-sort="sortTable"
      >
      </tableMove>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import bus from '../../libs/bus';
  import util from '../../libs/util';
  import dateFormat from '../../filters/date-format';
  import panelMove from '../../components/panel-move/index';
  import chartMove from '../../components/chart-move/chart-move';
  import tableMove from '../../components/table-move/table-move';
  import baseFn from '../../components/chart-move/chart-base';
  import numberSeparator from '../../filters/number-separator';
  import sortData from '../../filters/sort-table-data';

  export default {
    data() {
      return {
        overview: {
          shareAmt: {
            currentRange: '--', // 当前所选时间段的概览值
            preRange: '--', // 上个时间段的概览值
            ratio: '--', // 增长比率: (currentRange - preRange) / currentRange
          },
          shareDeviceAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          shareLinkClickAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          // 暂不支持
          // 新增用户
          newShareDeviceAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          // 总打开次数-->link点击占总打开次数比例
          viewAmt: {
            currentRange: '--',
            currentRangeRatio: '--',
            preRange: '--',
            ratio: '--',
          },
        },
        currentTab: 'shareAmt',
        shareAmt: {
          loaded: false,
          legendName: ['tabs'],
          metrics: ['shareAmt'],
          total: '--',
          average: '--',
        },
        shareDeviceAmt: {
          loaded: false,
          legendName: ['tabs'],
          metrics: ['shareDeviceAmt'],
          total: '--',
          average: '--',
        },
        shareLinkClickAmt: {
          loaded: false,
          legendName: ['tabs'],
          metrics: ['shareDeviceAmt'],
          total: '--',
          average: '--',
        },
        // 暂不支持 新增指标
        newShareDeviceAmt: {
          loaded: false,
          legendName: ['tabs'],
          metrics: ['newShareDeviceAmt'],
          total: '--',
          average: '--',
        },
        // 页面分享分析搜索内容
        sharePageFilter: '',
        // 绑定到table的数据，随排序、筛选而变化
        pageTableData: [],
        pageNoData: this.$t('common.loading'),

        // 用于取消请求
        source: axios.CancelToken.source(),
      };
    },
    components: {
      panelMove,
      chartMove,
      tableMove,
    },
    computed: {
      // 页面分享分析表头
      pageTableColumns() {
        const self = this;
        const list = [{
          key: 'pageNm',
          title: this.$t('shareDiss.pageName'),
          align: 'left',
          render(h, params) {
            return h('span', {
              class: 'page-name',
              on: {
                click: () => {
                  self.goPageDetail(params.row.pageId);
                },
              },
            }, params.row.pageNm);
          },
        }, {
          key: 'shareAmt',
          title: this.$t('shareDiss.shareAmt.tabs'),
          align: 'right',
          sortable: 'custom',
          render(h, params) {
            const value = numberSeparator(params.row.shareAmt);
            return h('span', value);
          },
        }, {
          key: 'shareDeviceAmt',
          title: this.$t('shareDiss.shareDeviceAmt.tabs'),
          align: 'right',
          render(h, params) {
            const value = numberSeparator(params.row.shareDeviceAmt);
            return h('span', value);
          },
        }, {
          key: 'shareLinkClickAmt',
          title: this.$t('shareDiss.shareLinkClickAmt.tabs'),
          align: 'right',
          render(h, params) {
            const value = numberSeparator(params.row.shareLinkClickAmt);
            return h('span', value);
          },
        },
        // 暂不支持指标
        {
          key: 'shareLinkClickUserAmt',
          title: this.$t('shareDiss.shareLinkClickDeviceAmt'),
          align: 'right',
          render(h, params) {
            const value = numberSeparator(params.row.shareLinkClickUserAmt);
            return h('span', value);
          },
        },
        {
          key: 'shareTipPro',
          title: this.$t('shareDiss.shareTipPro'),
          align: 'right',
          render(h, params) {
            const value = numberSeparator(params.row.shareTipPro);
            return h('span', value);
          },
        },
        // 暂不支持 新增指标
        // {
        //   key: 'newShareDeviceAmt',
        //   title: this.$t('shareDiss.newShareDeviceAmt.tabs'),
        //   align: 'right',
        //   render(h, params) {
        //     const value = numberSeparator(params.row.newShareDeviceAmt);
        //     return h('span', value);
        //   },
        // },
        {
          key: 'operation',
          title: this.$t('shareDiss.opreation'),
          align: 'center',
          render(h, params) {
            return h('i', {
              class: 'iconfont icon-Details tm-icon-font tm-icon-font-operation hover-style',
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  self.goPageDetail(params.row.pageId);
                },
              },
            });
          },
        }];
        return list;
      },
      // 求所选时间段跨天数 return Number
      selectedDateLen() {
        const oDate1 = bus.selectedDate[0].split('-');
        const oDate2 = bus.selectedDate[1].split('-');
        const strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
        const strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
        const len = (Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24) + 1;
        const iDays = parseInt(len, 0);
        return iDays;
      },
    },
    filters: {
      numberSeparator,
      sortData,
      dateFormat,
    },
    mounted() {
      bus.$on('on-app-change', () => {
        this.init();
      });
      bus.$on('on-platform-change', () => {
        this.init();
      });
      bus.$on('on-conditions-change', () => {
        this.init();
      });
      bus.$on('on-date-change', () => {
        this.init();
      });
      if (!bus.productInfo.productid) {
        return;
      }
      this.init();
    },
    beforeDestroy() {
      bus.$off('on-app-change');
      bus.$off('on-platform-change');
      bus.$off('on-conditions-change');
      bus.$off('on-date-change');
    },
    methods: {
      init() {
        this.clearData();
        this.getOverviewData();
        // 清空图表数据
        Object.keys(this.$refs).filter(v => v !== 'pageTable').forEach(x => this.$refs[x].clearData());
        this.onChangeTabs(this.currentTab);
        this.getPageTableData();
      },
      // date:日期yyyy-mm-dd，days：距离date天数
      getDay(date, days) {
        const today = new Date(date).valueOf();
        const selday = new Date(today + (days * 3600 * 1000 * 24));
        const year = selday.getFullYear();
        const oMonth = selday.getMonth() + 1;
        const month = oMonth >= 10 ? oMonth : `0${oMonth}`;
        const day = selday.getDate() >= 10 ? selday.getDate() : `0${selday.getDate()}`;
        return `${year}-${month}-${day}`;
      },
      /**
       * 获取同比所选时段的上个时间段
       * @param type {Boolean} 类型, 为true时 返回格式：2017-06-23 否则返回：170623
       **/
      getPreDate(type) {
        let end = this.getDay(bus.selectedDate[0], -1);
        const days = -this.selectedDateLen;
        let start = this.getDay(bus.selectedDate[0], days);
        if (type) {
          return [start, end];
        }
        end = dateFormat(end);
        start = dateFormat(start);
        return [start, end];
      },
      /**
       * 获取处理后概览值
       * @param num {Number} 类型, 所选时段的指标值
       * @param numPre {Number} 类型, 同比所选时段的上个时段的指标值
       **/
      getDivision(num, numPre) {
        let value = '--';
        if (num !== '--') {
          value = (((num - numPre) / numPre) * 100).toFixed(2);
          value = (num && !numPre) ? 100.00 : value;
          if (numPre * 1 === 0 && num * 1 !== 0) { // 上个时段为0 所选时段不为0 处理value为--
            value = '--';
          }
        }
        return value === 'NaN' || value === 'Infinity' ? '--' : value;
      },
      // 获取概览值数据
      fetchOverviewData(selectTime) {
        const params = {
          developerId: bus.developerid,
          productId: bus.productid,
          // 暂不支持 新增指标
          metrics: ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt', 'newShareDeviceAmt', 'viewAmt'],
          // metrics: ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt'],
          platformIds: bus.platform,
          startTime: dateFormat(selectTime[0]),
          endTime: dateFormat(selectTime[1]),
          partnerIds: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          versions: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        };
        return util.ajax.post('/app/rest/miniApp/query', params, { cancelToken: this.source.token });
      },
      // 所选时间段概览值
      getOverviewData() {
        const self = this;
        self.fetchOverviewData(bus.selectedDate).then((res) => {
          Object.keys(self.overview).forEach((v) => {
            if (v === 'viewAmt') {
              self.overview[v].currentRange = res[v].length ?
                baseFn.division(res.shareLinkClickAmt[0].value, res[v][0].value, 2) : 0;
              self.overview[v].currentRangeRatio = `${self.overview[v].currentRange}%`;
            } else {
              self.overview[v].currentRange = res[v].length ? res[v][0].value : 0;
              self[v].total = res[v][0].value;
              self[v].average = baseFn.division(res[v][0].value, self.selectedDateLen, 2);
            }
          });
          // 同比上个时间段概览值
          self.fetchOverviewData(self.getPreDate(true)).then((preRes) => {
            Object.keys(self.overview).forEach((v) => {
              // 兼容返回空数组
              if (v === 'viewAmt') {
                self.overview[v].preRange = preRes[v].length ?
                  baseFn.division(preRes.shareLinkClickAmt[0].value, preRes[v][0].value, 2) : 0;
              } else {
                self.overview[v].preRange = preRes[v].length ? preRes[v][0].value : 0;
              }
              self.overview[v].ratio =
              self.getDivision(self.overview[v].currentRange, self.overview[v].preRange);
            });
          });
        });
      },
      // 获取图表信息数据
      fetchChartData(metrics) {
        const params = {
          developerId: bus.developerid,
          productId: bus.productid,
          metrics,
          // 暂不支持 新增指标
          // metrics: ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt', 'newShareDeviceAmt'],
          platformIds: bus.platform,
          startTime: dateFormat(bus.selectedDate[0]),
          endTime: dateFormat(bus.selectedDate[1]),
          partnerIds: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          versions: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
          groupBy: 'day',
        };
        return util.ajax.post('/app/rest/miniApp/query', params, { cancelToken: this.source.token });
      },
      // 获取表格数据
      fetchTableData() {
        const params = {
          developerId: bus.developerid,
          productId: bus.productid,
          metrics: ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt', 'shareLinkClickUserAmt'],
          platformIds: bus.platform,
          startTime: dateFormat(bus.selectedDate[0]),
          endTime: dateFormat(bus.selectedDate[1]),
          partnerIds: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          versions: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
          groupBy: 'pageId',
          aggr: '1',
          verbose: '1',
        };
        return util.ajax.post('/app/rest/miniApp/query', params, { cancelToken: this.source.token });
      },
      // 处理表格数据
      getPageTableData() {
        this.fetchTableData().then((res) => {
          if (!res.length) this.pageNoData = this.$t('common.nodata');
          this.pageTableData = res.map((item) => {
            const tmp = JSON.parse(JSON.stringify(item));
            tmp.pageNm = item.pageNm || item.pageId;
            tmp.shareTipPro = baseFn.division(item.shareLinkClickAmt, item.shareAmt, 2);
            return tmp;
          });
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.errorTip'),
              duration: 3,
            });
          }
        });
      },
      // 跳转页面详情
      goPageDetail(pageid) {
        this.$router.push({
          name: 'sharePageDetail',
          params: {
            productid: this.$route.params.productid,
            pageid,
          },
        });
      },
      onChangeTabs(key) {
        this.currentTab = key;
        if (this[key].loaded) return;
        // 图例名称
        const legendName = this.$t(`shareDiss.${key}.tabs`).split(',');
        let stack;
        // talbe相关数据
        const table = {
          columns: this.setTableColumns(key, this[key].legendName),
          data: [],
        };
        const chart = {
          legendName,
          xaxisData: [],
          yaxis: [],
          series: [],
        };
        let xData = [];
        this.fetchChartData([key]).then((res) => {
          xData = res[key].map(x => x.value);
          chart.xaxisData = res[key].map(x => x.tag);

          table.data = JSON.parse(JSON.stringify(res[key]));

          chart.yaxis = [baseFn.setyAxisStyle('')];
          chart.series = [baseFn.setSeries('line', xData, legendName[0], stack, null)];

          this.drawChart(key, table, chart, stack);
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.errorTip'),
              duration: 3,
            });
          }
        });
      },
      /**
       * 图表转换，处理表格表头数据
       * @param  {[String]} key      [当前 Tabs标示]
       * @param  {[Array]} arr      [数据指标名称数组]
       * return [Object] 返回表格表头数据
       */
      setTableColumns(key, arr) {
        const columns = [
          {
            title: this.$t('transaction.date'),
            key: 'tag',
            sortable: 'custom',
            width: 120,
          },
        ];
        arr.forEach((x) => {
          columns.push({
            title: this.$t(`shareDiss.${key}.${x}`),
            key: 'value',
            sortable: 'custom',
            align: 'right',
            // render: (h, params) => (h('div', `${params.row[x]}${range}`)),
          });
        });
        columns.push({
          align: 'left',
          renderHeader(h) {
            return h('p', {
              style: {
                color: '#FFF',
              },
            });
//            return '<p style="color:#FFF;"></p>';
          },
          render() {
            return '';
          },
        });
        return columns;
      },
      /**
       * 将数据传递到图表组件
       * @param {[String]} key   [当前 tabs标示]
       * @param {[Object]} table [当前 tabs table 数据]
       * @param {[Object]} chart [当前 tabs chart 数据]
       * @param {[String]} stack [当前 tabs stack 标示(堆积图标示)]
       */
      drawChart(key, table, chart, stack) {
        const refsDom = this.$refs[key];
        this[key].loaded = true;
        refsDom.spinShow = false;
        refsDom.initTable(table.columns, table.data);
        refsDom.initChart(chart.legendName, chart.xaxisData, chart.yaxis, chart.series, stack);
      },
      onChangeChartType(type) {
        Object.keys(this.$refs).forEach((key) => {
          this.$refs[key].transformType = type === 'chart';
        });
      },
      // 图表导出数据
      exportData() {
        const refsDom = this.$refs[this.currentTab];
        const name = this.$t(`shareDiss.${this.currentTab}.tabs`);
        refsDom.exportTable(name);
      },
      // 页面分享分析导出数据
      exportPageData() {
        const refsDom = this.$refs.pageTable;
        const name = this.$t('shareDiss.pageShare');
        refsDom.exportTable(name);
      },
      /**
       * 自定义排序
       * @param  {[Object]} obj [点击排序列内容]
       * @param {String} name [table-move 绑定的refs 表格数据前缀 例：ref为pageTable，则此表格绑定数据为pageTableData]
       */
      sortTable(obj, tableData) {
        const data = tableData;
        const list = sortData(obj, data);
        this.pageTableData = list;
      },
      // 清空页面数据
      clearData() {
        this.overview = {
          shareAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          shareDeviceAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          shareLinkClickAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          // 暂不支持 新增指标
          newShareDeviceAmt: {
            currentRange: '--',
            preRange: '--',
            ratio: '--',
          },
          viewAmt: {
            currentRange: '--',
            currentRangeRatio: '--',
            preRange: '--',
            ratio: '--',
          },
        };
        // 暂不支持 新增指标
        // const tabList = ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt', 'newShareDeviceAmt'];
        const tabList = ['shareAmt', 'shareDeviceAmt', 'shareLinkClickAmt', 'newShareDeviceAmt'];
        tabList.forEach((v) => {
          this[v].loaded = false;
          this[v].total = '--';
          this[v].average = '--';
        });
        this.pageTableData = [];
        this.pageNoData = this.$t('common.loading');
      },
    },
  };
</script>
